import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, Cookie } from "lucide-react";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem("cookieConsent");
    if (!hasConsented) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    localStorage.setItem("cookieConsentDate", new Date().toISOString());
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    localStorage.setItem("cookieConsentDate", new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fade-in"
      style={{ backgroundColor: 'rgba(31, 31, 31, 0.95)', backdropFilter: 'blur(10px)' }}
    >
      <div className="container">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          {/* Content */}
          <div className="flex items-start gap-4 flex-1">
            <div 
              className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: 'var(--accent-muted)' }}
            >
              <Cookie className="w-5 h-5" style={{ color: 'var(--accent-primary)' }} />
            </div>
            <div>
              <h3 className="text-body font-medium mb-1" style={{ color: 'var(--text-inverse)' }}>
                We use cookies
              </h3>
              <p className="text-small" style={{ color: 'rgba(255,255,255,0.7)' }}>
                We use cookies to ensure proper functionality and improve your experience. By continuing to use this site, you consent to our use of cookies.{' '}
                <Link 
                  to="/cookies" 
                  className="underline hover:no-underline"
                  style={{ color: 'var(--accent-primary)' }}
                >
                  Learn more
                </Link>
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-3 ml-14 md:ml-0">
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-small rounded-lg transition-all hover:bg-white/10"
              style={{ color: 'rgba(255,255,255,0.7)' }}
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 text-small font-medium rounded-lg transition-all hover:opacity-90"
              style={{ backgroundColor: 'var(--accent-primary)', color: 'var(--text-primary)' }}
            >
              Accept Cookies
            </button>
          </div>

          {/* Close Button */}
          <button
            onClick={handleDecline}
            className="absolute top-4 right-4 md:hidden p-2 rounded-lg hover:bg-white/10"
          >
            <X className="w-4 h-4" style={{ color: 'rgba(255,255,255,0.7)' }} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
